module.exports = __webpack_public_path__ + "img/social6.edb46b89.svg";